<template>

  <div id="product-configuration-view" :class="{simple: isSimpleLayout}">


    <ViewTabList
        v-if="isLeftSidebarVisible"
        :createable-product-views="createableProductViews"
        :product-configuration-views="canvasViews"
        :disable-creating="productConfiguration.hasBlueprints()"
        @createNewProductConfigurationView="createNewProductConfigurationView"
        @newActiveTab="setActiveTab"
    >
    </ViewTabList>

    <div id="view-configurators">

      <CanvasView v-for="canvasView in canvasViews" :product-configuration-view="canvasView"
                  v-show="canvasView.active"></CanvasView>

      <script>
        if (window.hasOwnProperty('afterCanvasLoaded')) {
          window.afterCanvasLoaded();
        }
      </script>
    </div>

    <CanvasObjectsList v-if="activeCanvasView" :current-active="activeCanvasView"
                       @save="saveProductConfiguration"></CanvasObjectsList>

  </div>

</template>

<script>

import ViewTabList from "./../components/ViewTabList";
import CanvasView from "./../components/CanvasView";
import CanvasObjectsList from "./../components/CanvasObjectsList";

import ProductConfiguration from "./../structures/ProductConfiguration";
import Canvas from "./../structures/Canvas";
import requestHelper from "./../api/requestHelper";

import AppDebug from "./../AppDebug";
import configuration from "../configuration/Configuration";
import moduleLoader from "../loader/Loader";


export default {
  name: "ProductConfigurationView",
  components: {
    ViewTabList: () => moduleLoader.loadModule('ViewTabList'),
    CanvasObjectsList: () => moduleLoader.loadModule('CanvasObjectsList', 'SimpleCanvasObjectsList'),
    CanvasView: () => moduleLoader.loadModule('CanvasView')
  },
  data: () => ({
    productId: 4,
    productConfiguration: null
  }),
  props: {
    prodId: {
      type: [String, Number],
      default: null
    }
  },
  computed: {

    activeCanvasView() {
      const activeView = this.canvasViews.find(canvasView => canvasView.active);
      if (activeView)
        return activeView;
    },

    createableProductViews() {
      return this.productConfiguration.getCreateableProductViews();
    },

    canvasViews() {
      return this.productConfiguration.getProductConfigurationViews();
    },

    isLeftSidebarVisible() {

      return configuration.getConfig().template.showleftsidebar;

    },

    isSimpleLayout() {

      return configuration.getConfig().template.simple;

    }

  },
  methods: {

    async saveProductConfiguration(action) {

      const createdProductConfiguration = await this.productConfiguration.save();

      if (typeof action === "object") {

        if (action.hasOwnProperty('target')) {

          if (action.target === 'basket') {
            if (window.hasOwnProperty('addToBasket')) {
              window.addToBasket(createdProductConfiguration);
            }
          }

          if (action.target === 'wishlist') {
            if (window.hasOwnProperty('addToWishlist')) {
              window.addToWishlist(createdProductConfiguration);
            }
          }

          if (action.target === 'download') {
            const tab = window.open(requestHelper.createUrl(`/${createdProductConfiguration.id}/printfile/all`), '_blank');
            tab.focus();
          }

        }

      }

    },

    createNewProductConfigurationView(productViewId) {

      this.productConfiguration.createNewProductConfigurationView(productViewId);

    },

    setActiveTab(productViewConfigurationId) {

      this.productConfiguration.setActiveProductConfigurationView(productViewConfigurationId);

    },

    getParameterByName(name, url = null) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

  },
  beforeMount() {

    // await this.loadCreateableProductViews(this.productId);

    console.log('set prod id');

    this.productId = this.prodId || this.productId;

    let productConfigurationId = this.getParameterByName('prodconf');

    if (window['w2p_prod']) {
      if (window['w2p_prod'].hasOwnProperty('configId')) {
        productConfigurationId = window['w2p_prod'].configId;
      }
    }

    this.productConfiguration = new ProductConfiguration(this.productId, productConfigurationId);

    // console.log('load existing config');
    //
    // if ( productConfigurationId )
    //     this.productConfiguration.loadExistingProductConfiguration( productConfigurationId );
    //
    // this.productConfiguration.createDefaultProductConfigurationViewsWhenLoadProduct();

  }
}
</script>

<style lang="scss">

@import "~@/assets/scss/fonts";
@import "~@/assets/scss/var";

#app {
  display: flex;
}

#product-configuration-view {
  display: inline-flex;
  flex-direction: row;

  .sidebar {
    display: flex;
    flex-direction: column;
    padding: 20px 10px 10px 10px;
    box-sizing: border-box;
    background-color: #E9E9F0;
    width: 300px;
    overflow: auto;
    flex-shrink: 0;
  }

  #view-configurators {
    flex-grow: 1;
  }

}

.option-button {
  height: 42px;
}

</style>

<style lang="scss">
@media only screen and (max-width: 600px) {
  #product-configuration-view {
    display: block;

    .sidebar {
      width: 100%;
    }

    .view-configurator {
      .view-configurator-view {
        width: 100%;

        .canvas-wrapper {
          width: 100%;

          .canvas-container {
            width: 100% !important;

            canvas {
              width: 100% !important;
              height: auto !important;
            }
          }
        }
      }
    }
  }
}
</style>